import { createSlice } from "@reduxjs/toolkit";
import { getUpdateStatusAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getUpdateStatusSlice = createSlice({
  name: "getUpdateStatus",
  initialState: data,
  reducers: {
   getUpdateStatusSlice(state) {
      state.isLoading = true;
    },
   getUpdateStatusSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getUpdateStatusSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getUpdateStatusSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getUpdateStatusHandler = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(getUpdateStatusAction.getUpdateStatusSlice());
    const response: any = await getUpdateStatusAPI(id,data);
    
    dispatch(getUpdateStatusAction.getUpdateStatusSliceSuccess(response));
  } catch (e: any) {
    dispatch(getUpdateStatusAction.getUpdateStatusSliceFailure(e?.response?.data));
  }
};
export default getUpdateStatusSlice.reducer;
export const getUpdateStatusAction = getUpdateStatusSlice.actions;
